import { render, staticRenderFns } from "./ot-breadcrumbs-wrapper.vue?vue&type=template&id=72d2fb30&scoped=true&"
import script from "./ot-breadcrumbs-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-breadcrumbs-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-breadcrumbs-wrapper.vue?vue&type=style&index=0&id=72d2fb30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2fb30",
  null
  
)

export default component.exports